/* LA Flight School :: Sales Elements :: Book In Place (sx-book.js)
   Book → (picker if no flight) → weight check + Terms consent → Cowlendar pop-up, on the same page.
   Data: window.SXD (snippets/sx-data.liquid). Native anchors: snippets/sx-book.liquid.
   Public API (used by the element scripts): window.UBook.open({k,m,pax,src}), .gift({k,m,pax,src}), .close().
   Oct 11 2026: optional per-flight f.h (dialog heading) and f.len (length label, e.g. '2 Hours') for the
   first-lesson flights from snippets/fl-book.liquid; a flight with no weight limit (simulator) asks for Terms only,
   and its consent record and phone line leave out the weight limit. */
(function () {
  'use strict';
  if (window.UBook && window.UBook.__sx) return;
  var D = window.SXD || {}, F = D.f || {};
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOTS = '.dfb,.dfb1,.dfb5,.dfb6,.dfb7,.dfb8,.dfb9,.uel,.spx,.spc,.sxpg,.ubk-scope,[data-sx-scope]';

  function money(n) { return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function price(k, m, pax) { var f = F[k]; if (!f) return 0; return ((pax && f.p2) ? f.p2 : f.p)[m] || 0; }
  function name(k, pax) { var f = F[k]; return f ? f.n + (pax && f.p2 ? ' + Passenger' : '') : 'Discovery Flight'; }
  function nkey(k, pax) { return (k === 'lux' && pax) ? 'luxpax' : k; }
  function native(k, m, pax) { return document.querySelector('[data-sx-native="' + nkey(k, pax) + '-' + m + '"]'); }

  /* Natives must never navigate if Cowlendar has not bound yet: a bubble-phase listener on the
     container runs after Cowlendar's own listener on the anchor and only blocks the navigation. */
  function guardNatives() {
    var boxes = document.querySelectorAll('[data-sx-natives]');
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].__sxg) continue; boxes[i].__sxg = 1;
      boxes[i].addEventListener('click', function (e) { e.preventDefault(); });
    }
  }

  function modalOpen() {
    if (document.body.classList.contains('cowlendar-overflow-fixed')) return true;
    if (document.querySelector('.cowlendar-iframe,.cow-modal.cow-open')) return true;
    var b = document.querySelector('.cowlendar-bg,.cowlendar-modal');
    return !!(b && b.offsetParent !== null && getComputedStyle(b).display !== 'none');
  }

  /* ---------- dialog shell (native <dialog>, Esc closes, focus returns) ---------- */
  var M = null, opener = null;
  function shell() {
    if (M) return M;
    M = document.createElement('dialog');
    M.className = 'ubk-m sx-m';
    M.setAttribute('aria-labelledby', 'ubk-mh');
    M.innerHTML = '<div class="ubk-w"><button type="button" class="ubk-x" aria-label="Close">&times;</button><div class="ubk-c"></div></div>';
    document.body.appendChild(M);
    M.querySelector('.ubk-x').addEventListener('click', close);
    M.addEventListener('click', function (e) { if (e.target === M) close(); });
    M.addEventListener('close', function () {
      document.documentElement.classList.remove('ubk-lock');
      if (opener && opener.focus) { try { opener.focus(); } catch (e) {} }
    });
    return M;
  }
  function show(html, focusSel) {
    var d = shell();
    d.querySelector('.ubk-c').innerHTML = html;
    document.documentElement.classList.add('ubk-lock');
    if (d.showModal) { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
    var f = d.querySelector(focusSel || 'button:not(.ubk-x),a,input');
    if (f) setTimeout(function () { try { f.focus(); } catch (e) {} }, 30);
    return d;
  }
  function close() {
    if (!M) return;
    if (M.close && M.open) M.close();
    else { M.removeAttribute('open'); document.documentElement.classList.remove('ubk-lock'); }
  }
  function rg(c, sel, cb) {
    var it = [].slice.call(c.querySelectorAll(sel));
    it.forEach(function (b, n) {
      b.addEventListener('click', function () { cb(b); });
      b.addEventListener('keydown', function (ev) {
        var d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[ev.key];
        if (d) { ev.preventDefault(); var x = it[(n + d + it.length) % it.length]; x.click(); x.focus(); }
      });
    });
  }

  /* ---------- picker: for Book buttons that don't name a flight ---------- */
  function picker(sel) {
    var keys = ['one', 'two', 'lux', 'multi'].filter(function (k) { return F[k]; });
    var s = { k: (sel && F[sel.k] && sel.k !== 'sporty') ? sel.k : 'one', m: (sel && +sel.m) || 60, pax: !!(sel && sel.pax), src: sel && sel.src };
    var h = '<p class="ubk-k">Every Flight Flies The Full Route</p><h2 id="ubk-mh">Book A Discovery Flight</h2>' +
      '<div class="ubk-fl" role="radiogroup" aria-label="Choose Your Flight">' + keys.map(function (k) {
        return '<button type="button" role="radio" data-k="' + k + '"><b>' + esc(F[k].s) + '</b><span data-p></span></button>';
      }).join('') + '</div>' +
      '<div class="ubk-ln" role="radiogroup" aria-label="Choose The Length">' + [60, 90, 120].map(function (m) {
        return '<button type="button" role="radio" data-m="' + m + '">' + m + ' Min</button>';
      }).join('') + '</div>' +
      '<button type="button" class="upx" role="switch" aria-checked="false" data-pax-sw hidden><span class="upx-t" aria-hidden="true"><i></i></span><span class="upx-l">Add A Passenger</span><span class="upx-a" data-pax-add></span></button>' +
      '<div class="ubk-sum" aria-live="polite"><span data-n></span><b data-t></b></div>' +
      '<button type="button" class="ubk-go">Choose My Time</button>' +
      '<p class="ubk-f">Next comes a quick weight-limit check, then the live calendar. Prices are all-in: airplane, fuel and instructor.</p>';
    var d = show(h), c = d.querySelector('.ubk-c');
    function paint() {
      var f = F[s.k]; if (!f.p2) s.pax = false;
      c.querySelectorAll('.ubk-fl button').forEach(function (b) {
        var on = b.getAttribute('data-k') === s.k; b.setAttribute('aria-checked', on); b.tabIndex = on ? 0 : -1;
        b.querySelector('[data-p]').textContent = money(F[b.getAttribute('data-k')].p[s.m]);
      });
      c.querySelectorAll('.ubk-ln button').forEach(function (b) {
        var on = +b.getAttribute('data-m') === s.m; b.setAttribute('aria-checked', on); b.tabIndex = on ? 0 : -1;
      });
      var sw = c.querySelector('[data-pax-sw]'); sw.hidden = !f.p2; sw.setAttribute('aria-checked', String(s.pax));
      if (f.p2) sw.querySelector('[data-pax-add]').textContent = '+' + money(f.p2[s.m] - f.p[s.m]);
      c.querySelector('[data-n]').textContent = name(s.k, s.pax) + ' · ' + s.m + ' min';
      c.querySelector('[data-t]').textContent = money(price(s.k, s.m, s.pax));
    }
    rg(c, '.ubk-fl button', function (b) { s.k = b.getAttribute('data-k'); paint(); });
    rg(c, '.ubk-ln button', function (b) { s.m = +b.getAttribute('data-m'); paint(); });
    c.querySelector('[data-pax-sw]').addEventListener('click', function () { s.pax = !s.pax; paint(); });
    c.querySelector('.ubk-go').addEventListener('click', function () { gate({ k: s.k, m: s.m, pax: s.pax, src: s.src }); });
    paint();
  }

  /* ---------- weight check + Terms consent (same record as the site's other gates) ---------- */
  function limits(f, pax) {
    var w = f.w || {}; if (!w.per) return '';
    var sub = w.comb ? 'per person, and ' + w.comb + ' lb for ' + (pax ? 'all of you' : 'the two of you') + ' together.' : 'per flyer. It comes from the aircraft, not from us.';
    return '<div class="sx-wbox"><span class="sx-wlab">Weight Limit For This Flight</span><span class="sx-wbig">' + w.per + ' lb</span>' +
      '<p class="sx-wsub">' + sub + (w.ac ? ' You&rsquo;ll fly the <strong>' + esc(w.ac) + '</strong>.' : '') + ' We weigh in on the day, so it&rsquo;s worth a quick check now.</p></div>';
  }
  function record(sel) {
    var f = F[sel.k], w = f.w || {}, pax = !!(sel.pax && f.p2);
    var lim = w.per && w.comb ? w.per + ' lbs per person, ' + w.comb + ' lbs combined' : w.per ? w.per + ' lbs' : 'the published limit for this flight';
    var s = 'ACCEPTED ' + (new Date()).toISOString() + ' | ' + f.n + (pax ? ' + passenger' : '') + ' | ' + sel.m + ' min | $' + price(sel.k, sel.m, pax) +
      ' | ' + (w.per ? 'Confirmed within published weight limit (' + lim + ') and agreed' : 'Agreed') + ' to the Discovery Flight Terms & Conditions, which incorporate the Return & Refund Policy and the Terms of Service.';
    try { localStorage.setItem('lafs_consent_' + (f.gk || sel.k), s); } catch (e) {}
    try {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Terms accepted': s } }) }).catch(function () {});
    } catch (e) {}
  }
  function gate(sel) {
    var f = F[sel.k]; if (!f) { picker(sel); return; }
    var pax = !!(sel.pax && f.p2);
    var h = '<p class="ubk-k">One Quick Check</p><h2 id="ubk-mh">' + (f.h || 'You&rsquo;re Almost In The Air') + '</h2>' +
      '<div class="sx-sel"><span><b>' + esc(name(sel.k, pax)) + '</b><small>' + (f.len || sel.m + ' Min') + ' &middot; ' + (pax ? 'Instructor + 2' : esc(f.seats)) + ' &middot; Van Nuys</small></span><strong>' + money(price(sel.k, sel.m, pax)) + '</strong></div>' +
      limits(f, pax) +
      '<label class="sx-agree"><input type="checkbox" data-sx-cb><span>' + ((f.w && f.w.per) ? 'I&rsquo;m within the weight limit and I agree to the' : 'I agree to the') + ' <a href="' + esc(D.terms || '/pages/discovery-flight-terms') + '" target="_blank" rel="noopener">Terms &amp; Conditions</a>.</span></label>' +
      '<div class="sx-acts"><button type="button" class="ubk-go" data-sx-go disabled>Yes, Choose My Time</button><button type="button" class="sx-no" data-sx-no>Not Yet</button></div>' +
      '<p class="ubk-f">' + ((f.w && f.w.per) ? 'Close to the limit, or not sure? Call' : 'Questions first? Call') + ' <a href="tel:' + esc(D.tel || '+18182908249') + '">' + esc(D.phone || '(818) 290-8249') + '</a> before you book and we&rsquo;ll talk it through.</p>';
    var d = show(h, '[data-sx-cb]'), c = d.querySelector('.ubk-c'), cb = c.querySelector('[data-sx-cb]'), go = c.querySelector('[data-sx-go]');
    cb.addEventListener('change', function () { go.disabled = !cb.checked; cb.closest('.sx-agree').classList.toggle('ok', cb.checked); });
    c.querySelector('[data-sx-no]').addEventListener('click', close);
    go.addEventListener('click', function () {
      if (!cb.checked) return;
      record(sel);
      fire(sel);
    });
  }

  /* ---------- open Cowlendar ---------- */
  function busy(b, on) { if (!b || !b.classList) return; b.classList.toggle('ubk-busy', !!on); if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); }
  function fire(sel) {
    var a = native(sel.k, sel.m, sel.pax), src = sel.src;
    if (!a) { phone(sel); return; }
    close();
    guardNatives();
    busy(src, true);
    var tries = 0;
    (function attempt() {
      if (modalOpen()) { busy(src, false); return; }
      if (tries < 4) { tries++; try { a.click(); } catch (e) {} setTimeout(attempt, 1600); return; }
      busy(src, false);
      var sid = (a.getAttribute('data-cowlendar-btn') || '').split('-');
      if (sid.length === 2) location.assign(location.pathname + '?cow_sid=' + sid[0] + '&cow_vid=' + sid[1]);
    })();
  }
  function phone(sel) {
    var pax = !!(sel.pax && F[sel.k] && F[sel.k].p2);
    show('<p class="ubk-k">' + esc(name(sel.k, pax)) + ' &middot; ' + ((F[sel.k] && F[sel.k].len) || sel.m + ' Min') + ' &middot; ' + money(price(sel.k, sel.m, pax)) + '</p>' +
      '<h2 id="ubk-mh">Book This One By Phone</h2>' +
      '<p class="ubk-f">Online booking for this flight opens shortly. Call or text <a href="tel:' + esc(D.tel) + '">' + esc(D.phone) + '</a>, 9 AM to 9 PM, seven days, and we&rsquo;ll book your time.</p>' +
      '<a class="ubk-go" href="tel:' + esc(D.tel) + '">Call ' + esc(D.phone) + '</a>');
  }

  /* ---------- gift: a native Shopify gift-card variant with recipient details ---------- */
  function gift(sel) {
    var f = F[sel.k]; if (!f || !f.g) { if (D.gift) location.assign(D.gift); return; }
    var pax = !!(sel.pax && f.g2), m = +sel.m || 60, vid = (pax ? f.g2 : f.g)[m]; if (!vid) { if (D.gift) location.assign(D.gift); return; }
    opener = (sel && sel.src) || document.activeElement;
    var today = new Date(), max = new Date(Date.now() + 90 * 864e5);
    function d2(x) { return x.getFullYear() + '-' + ('0' + (x.getMonth() + 1)).slice(-2) + '-' + ('0' + x.getDate()).slice(-2); }
    var h = '<p class="ubk-k">Gift Details</p><h2 id="ubk-mh">' + esc(name(sel.k, pax)) + '</h2>' +
      '<p class="ubk-f sx-gsum">' + (f.len || m + ' Minutes') + ' &middot; ' + money(price(sel.k, m, pax)) + ' Gift Certificate &middot; Never Expires</p>' +
      '<form class="sx-gf" novalidate><p class="sx-err" hidden></p>' +
      '<label>Who Is It For?<input type="text" name="to" autocomplete="off" placeholder="Their name, as it should be printed"></label>' +
      '<fieldset class="sx-opt" data-opt="send"><legend>Where Should We Send It?</legend>' +
      '<button type="button" class="on" data-v="them">Email It To Them</button><button type="button" data-v="me">Email It To Me</button></fieldset>' +
      '<label data-email>Their Email Address<input type="email" name="email" autocomplete="off" placeholder="name@example.com"></label>' +
      '<label>Deliver On (Optional)<input type="date" name="date" min="' + d2(today) + '" max="' + d2(max) + '"></label>' +
      '<label>Your Message (Optional)<textarea name="msg" maxlength="200" placeholder="Whatever you would write in the card"></textarea></label>' +
      '<label>Who Is It From?<input type="text" name="from" autocomplete="off" placeholder="Your name, as it should appear"></label>' +
      '<fieldset class="sx-opt" data-opt="show"><legend>Print The Amount On It?</legend>' +
      '<button type="button" class="on" data-v="Hidden">Keep It Off</button><button type="button" data-v="Shown">Show The Amount</button></fieldset>' +
      '<button type="submit" class="ubk-go">Add To Cart</button>' +
      '<p class="ubk-f">Leave the date blank and it arrives as soon as the order is paid. Rather do it by phone? Call ' + esc(D.phone) + ', 9 to 9, seven days.</p></form>';
    var d = show(h, 'input[name=to]'), c = d.querySelector('.ubk-c'), fm = c.querySelector('form');
    c.querySelectorAll('.sx-opt').forEach(function (fs) {
      fs.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        fs.querySelectorAll('button').forEach(function (x) { x.classList.toggle('on', x === b); });
        if (fs.getAttribute('data-opt') === 'send') c.querySelector('[data-email]').hidden = b.getAttribute('data-v') !== 'them';
      });
    });
    function opt(n) { var b = c.querySelector('[data-opt="' + n + '"] button.on'); return b ? b.getAttribute('data-v') : ''; }
    fm.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = function (n) { return (fm.elements[n].value || '').trim(); }, err = c.querySelector('.sx-err');
      function fail(t, el) { err.textContent = t; err.hidden = false; if (el) el.focus(); }
      if (!v('to')) return fail('Please tell us who the certificate is for.', fm.elements.to);
      if (!v('from')) return fail('Please add your name, so the certificate says who it is from.', fm.elements.from);
      var to = opt('send');
      if (to === 'them' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v('email'))) return fail('Please add the email address the certificate should go to.', fm.elements.email);
      var props = { 'Recipient name': v('to'), 'From': v('from'), 'Amount on certificate': opt('show') || 'Hidden' };
      if (v('msg')) props['Message'] = v('msg');
      if (to === 'them') {
        props['__shopify_send_gift_card_to_recipient'] = 'true'; props['Recipient email'] = v('email');
        if (v('date')) { props['Send on'] = v('date'); props['__shopify_offset'] = String(new Date().getTimezoneOffset()); }
      } else if (v('date')) props['Deliver on'] = v('date');
      var go = fm.querySelector('button[type=submit]'); go.disabled = true; go.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +vid, quantity: 1, properties: props }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { location.assign('/cart'); })
        .catch(function () { go.disabled = false; go.textContent = 'Add To Cart'; fail('That did not go through. You can also order by phone on ' + D.phone + '.'); });
    });
  }

  /* ---------- public entry ---------- */
  function open(sel) {
    sel = sel || {}; sel.m = +sel.m || 60;
    opener = sel.src || document.activeElement;
    if (!sel.k || !F[sel.k]) { picker(sel); return; }
    gate(sel);
  }
  window.UBook = { open: open, gift: gift, close: close, picker: picker, __sx: 1 };

  /* Links to the discovery page with ?flight=&min=&pax= inside a sales block book in place too. */
  function parse(a) {
    var href = a.getAttribute('href') || ''; if (!href || href.charAt(0) === '#') return null;
    var u; try { u = new URL(href, location.href); } catch (e) { return null; }
    if (u.host !== location.host || u.pathname !== D.disc) return null;
    if (!u.searchParams.get('flight')) return (u.hash === '#booking' || u.hash === '#book') ? { k: '', m: +u.searchParams.get('min') || 60, pax: false } : null;
    return { k: u.searchParams.get('flight'), m: +u.searchParams.get('min') || 60, pax: u.searchParams.get('pax') === '1' };
  }
  /* Gift links: data-sx-gift (with data-k/data-m/data-pax) opens the gift form in place. */
  function giftSel(a) {
    if (!a.hasAttribute('data-sx-gift')) return null;
    var k = a.getAttribute('data-k') || 'one'; if (!F[k] || !F[k].g) return null;
    return { k: k, m: +a.getAttribute('data-m') || 60, pax: a.getAttribute('data-pax') === '1' };
  }
  document.addEventListener('click', function (ev) {
    if (ev.button > 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    var a = ev.target.closest && ev.target.closest('[data-ubook],[data-sx-gift],a[href]');
    if (!a || !a.closest(ROOTS) || a.closest('[data-sx-natives]')) return;
    var g = giftSel(a);
    if (g) { ev.preventDefault(); ev.stopPropagation(); g.src = a; gift(g); return; }
    if (a.hasAttribute('data-sx-gift')) return;
    var s = null;
    if (a.hasAttribute('data-ubook')) s = { k: a.getAttribute('data-k') || '', m: +a.getAttribute('data-m') || 60, pax: a.getAttribute('data-pax') === '1' };
    else s = parse(a);
    if (!s) return;
    ev.preventDefault(); ev.stopPropagation(); if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
    s.src = a; open(s);
  }, true);

  /* Same-page deep link from an element: #book-sporty-90 opens the weight check for that flight. */
  function hash() {
    var m = (location.hash || '').match(/^#sx-book-(one|two|lux|luxpax|multi|sporty)-(60|90|120)$/);
    if (!m) return;
    var k = m[1] === 'luxpax' ? 'lux' : m[1];
    open({ k: k, m: +m[2], pax: m[1] === 'luxpax' });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { guardNatives(); hash(); });
  else { guardNatives(); hash(); }
})();
